import React from 'react';

import { ArrowCircleDownFill } from '@lyearn/icons';
import { Box } from '@lyearn/ui';

interface ScrollToBottomButtonProps {
  atBottom: boolean;
  onClick: () => void;
}

const ScrollToBottomButton = ({ atBottom, onClick }: ScrollToBottomButtonProps) => {
  if (atBottom) {
    return null;
  }

  return (
    <Box className="h-32 w-32 rounded-full bg-bg-primary absolute bottom-0 start-1/2 transform -translate-x-1/2 -translate-y-1/2 rtl:translate-x-1/2 shadow-04">
      <ArrowCircleDownFill
        className="min-h-[3.2rem] min-w-[3.2rem] hover:cursor-pointer"
        height={32}
        width={32}
        onClick={onClick}
      />
    </Box>
  );
};

export default React.memo(ScrollToBottomButton);
